<template>
  <b-container id="sign-up">
    <div class="story-container">
      <div class="story-container-inner">
        <h1>Sign up</h1>
        <div class="separator" />
        <p>
          Be sure to sign up for our email newsletters to receive our weekly
          content, latest video highlights,
          <br />
          up-to-date news, features, ticket specials and more!
        </p>
        <a
          class="signup-button"
          v-ePitchTracking="{
            site: 'nikko',
            category: 'Link - Socials',
            label: 'Sign Up',
          }"
          href="https://www.mlb.com/cubs/forms/newsletter-registration-respect"
          target="_blank"
        >
          <svg width="15" height="12" viewBox="0 0 15 12" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13.594 0H1.406C.63 0 0 .672 0 1.5v9c0 .828.63 1.5 1.406 1.5h12.188C14.37 12 15 11.328 15 10.5v-9c0-.828-.63-1.5-1.406-1.5zm0 1.5v1.275c-.657.57-1.704 1.458-3.943 3.328C9.157 6.517 8.18 7.511 7.5 7.5c-.68.012-1.658-.983-2.15-1.397a295.951 295.951 0 01-3.944-3.328V1.5h12.188zm-12.188 9V4.7c.672.57 1.624 1.37 3.075 2.583C5.12 7.82 6.242 9.007 7.5 9c1.251.007 2.359-1.163 3.02-1.717A504.044 504.044 0 0013.593 4.7v5.8H1.406z" fill="#FFF" fill-rule="nonzero"/></svg>
          <span>Sign Up</span>
        </a>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "SignUp",
};
</script>

<style lang="scss" scoped>
#sign-up {
  width: 100vw;
  padding: 0 20px;
  @media (max-width: $md) {
    padding-left: 0;
    padding-right: 0;
  }
  .story-container {
    display: flex;
    background-image: url("~@/assets/images/bg/texture_super_wide.png");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
  }
  .story-container-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 52px;
    padding-bottom: 68px;
    padding-left: 15px;
    padding-right: 15px;
    box-shadow: 0 6px 30px 0px rgba(0, 0, 0, 0.3);
    @media (max-width: $md) {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 47px;
      padding-bottom: 52px;
    }
    h1 {
      font-family: Poppins-Bold;
      font-size: 34px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 42px;
      text-transform: uppercase;
    }
    .separator {
      width: 115px;
      height: 4px;
      background: #eaeaea;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    p {
      font-family: AvenirNext-Medium;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 31px;
    }
    .signup-button {
      width: 145px;
      max-width: 100%;
      height: 36px;
      background-image: linear-gradient(180deg, #e13a3e 0%, #e51318 99%);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      &:hover {
        background-image: linear-gradient(180deg, #e13a3e 0%, #bd070b 99%);
        cursor: pointer;
        text-decoration: none;
      }
      span {
        font-family: "Poppins-Bold";
        font-size: 13px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        text-transform: uppercase;
      }
      img,
      svg {
        width: 15px;
        height: 12px;
        margin-right: 5px;
      }
    }
  }
}
</style>

